export default {
      id: "court-house-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#court-house",
      toString: function () {
        return this.url;
      }
    }